import { AppNavigationProp, RootStackParamList } from './navigationTypes'
//import LZString from 'lz-string';

export const resetNavigation = (navigation: AppNavigationProp, route: keyof RootStackParamList) => {
  navigation.reset({
    index: 0,
    routes: [{ name: route }],
  })
}

// Get the current active route from nested navigators
export const getCurrentRoute = (state: any): any => {
  if (!state?.routes) return null
  
  // If there's an index, use it to get the active route
  if (state.index !== undefined && state.routes[state.index]) {
    const currentRoute = state.routes[state.index]
    
    // If current route has nested state, get the active route from it
    if (currentRoute.state) {
      const nestedRoute = getCurrentRoute(currentRoute.state)
      // Return the nested route if it exists, otherwise return the current route
      return nestedRoute || currentRoute
    }
    
    return currentRoute
  }
  
  // If no index, assume the first route is active (common in some navigator types)
  if (state.routes.length > 0) {
    const firstRoute = state.routes[0]
    
    // If first route has nested state, get the active route from it
    if (firstRoute.state) {
      const nestedRoute = getCurrentRoute(firstRoute.state)
      return nestedRoute || firstRoute
    }
    
    return firstRoute
  }
  
  return null
}

// Get the active route name chain from root -> leaf (useful for nested navigators)
export const getActiveRouteNameChain = (state: any): string[] => {
  if (!state?.routes || state.routes.length === 0) return []

  const getScreenChainFromParams = (params: any): string[] => {
    const chain: string[] = []
    let cursor: any = params
    // React Navigation nested params convention: { screen: 'X', params: { screen: 'Y', params: ... } }
    while (cursor && typeof cursor === 'object' && typeof cursor.screen === 'string') {
      chain.push(cursor.screen)
      cursor = cursor.params
    }
    return chain
  }

  const index =
    state.index !== undefined && state.routes[state.index]
      ? state.index
      : 0

  const route = state.routes[index]
  const name = route?.name ? [route.name] : []

  if (route?.state) {
    return [...name, ...getActiveRouteNameChain(route.state)]
  }

  // Important for first navigation clicks on web:
  // sometimes nested navigators aren't mounted yet, but the intent is stored in route.params.screen.
  const paramChain = getScreenChainFromParams(route?.params)
  return [...name, ...paramChain]
}

/*export function encodeParam(value: any) {
  try {
    return LZString.compressToBase64(JSON.stringify(value));
  } catch {
    return '';
  }
}

export function decodeParam(value: any) {
  try {
    const json = LZString.decompressFromBase64(value);
  return json ? JSON.parse(json) : null;
  } catch {
    return null;
  }
}*/

